<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <el-form :model="queryParams" ref="queryParams" size="small" v-show="showSearch" label-width="120px">
          <el-row :gutter="24" type="flex" justify="right">
            <el-col :span="6">
              <el-form-item label="设备编号" prop="eqptNum">
                <el-input v-model="queryParams.eqptNum" placeholder="请输入设备编号" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="设备名称" prop="eqptName">
                <el-input v-model="queryParams.eqptName" placeholder="请输入设备名称" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="校验类型" prop="eqptType">
                <el-input v-model="queryParams.eqptType" placeholder="请输入校验类型" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="校准方式" prop="eqptWay">
                <el-input v-model="queryParams.eqptWay" placeholder="请输入校准方式" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" type="flex" justify="right">
            <el-col :span="6">
              <el-form-item label="校准/检定单位" prop="eqptOrg">
                <el-input v-model="queryParams.eqptOrg" placeholder="请输入校准/检定单位" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="证书编号" prop="certificateNo">
                <el-input v-model="queryParams.certificateNo" placeholder="请输入证书编号" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="检定/校准结论" prop="eqptConclusion">
                <el-input v-model="queryParams.eqptConclusion" placeholder="请输入检定/校准结论" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="检定/校准日期" prop="eqptDateRange">
                <el-date-picker v-model="queryParams.eqptDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                                style="width: 100%;" />
              </el-form-item>
            </el-col>
          </el-row>
          <div style="text-align: center;margin-bottom: 10px;">
            <!-- <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
            <el-button type="success" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
            <el-button type="warning" icon="el-icon-download" size="mini" @click="exportToExcel">导出</el-button> -->
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleQuery="handleQuery" @handleAdd="handleAdd" @exportToExcel="exportToExcel" />
          </div>
          <el-table id="table" :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }"
                    row-key="_uniqueKey" ref="calibrationTable" height="500">
            <el-table-column label="所属项目类别" align="left" prop="projectCategory" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="设备编号" align="left" prop="eqptNum" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="设备名称" align="left" prop="eqptName" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="校验类型" align="left" prop="eqptType" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column label="校准方式" align="left" prop="eqptWay" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column label="校准/检定单位" align="left" prop="eqptOrg" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="检定/校准结论" align="left" prop="eqptConclusion" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="证书编号" align="left" prop="certificateNo" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="预定计划时间" align="left" prop="planTime" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="校准周期(月)" align="left" prop="eqptCycle" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="检定/校准日期" align="left" prop="eqptDate" min-width="180" show-overflow-tooltip sortable>
              <template slot-scope="scope">
                <span>{{ formatDate(scope.row.eqptDate) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="有效期至" align="left" prop="eqptValidity" min-width="120" show-overflow-tooltip sortable>
              <template slot-scope="scope">
                <span>{{ formatDate(scope.row.eqptValidity) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="相关文件" align="left" min-width="260">
              <template slot-scope="scope">
                <div v-if="scope.row.files && scope.row.files.length > 0" class="file-list">
                  <span v-for="(file, index) in scope.row.files" :key="index">
                    <el-link type="primary" @click="downloadFile(file)" :underline="false">
                      <i class="el-icon-document"></i> {{file.fileName}}
                    </el-link>
                    <span v-if="index < scope.row.files.length - 1" class="file-separator">、</span>
                  </span>
                </div>
                <span v-else>无</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="left" width="200" fixed="right">
              <template slot-scope="scope">
                <!-- <el-button type="text" size="small" @click="handleEdit(scope.row)">修改</el-button> -->
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" @handleEdit="handleEdit(scope.row)" @handleDelete="handleDelete(scope.row)" />
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.currPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-form>
      </el-col>
    </el-row>

    <!-- 引入新增/修改弹窗组件 -->
    <AddAndEdit ref="addEdit" @refresh="getList" :eqpt-num="selectedEqptNum" :eqpt-name="selectedEqptName" />
  </div>
</template>

<script>
import AddAndEdit from './calibrationAddAndEdit.vue';
import { queryEqptVerificationList, exportEqptVerificationExcel, deleteEqptVerification } from '@/api/contract/contract';
export default {
  name: 'Equipment-calibration-list',
  components: { AddAndEdit },
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      optPerm: {},
      // 显示搜索条件
      showSearch: true,
      tableData: [],
      // 遮罩层
      loading: true,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 10,
        eqptNum: undefined,
        eqptName: undefined,
        eqptType: undefined,
        eqptWay: undefined,
        eqptOrg: undefined,
        certificateNo: undefined,
        eqptConclusion: undefined,
        eqptDateRange: []
      },
      // 设备信息（用于从设备管理跳转过来时的预填充）
      selectedEqptNum: '',
      selectedEqptName: '',
      // 测试数据
      testData: []
    };
  },
  created () {
    this.getList();
  },
  methods: {
    // 格式化日期，只保留日期部分
    formatDate (dateTimeString) {
      if (!dateTimeString) return '';
      // 如果包含时间，则只返回日期部分
      if (dateTimeString.includes(' ')) {
        return dateTimeString.split(' ')[0];
      }
      return dateTimeString;
    },
    // 搜索
    handleQuery () {
      this.queryParams.currPage = 1
      this.getList()
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.queryParams.currPage = 1
      this.getList()
    },
    handleCurrentChange (val) {
      this.queryParams.currPage = val
      this.getList()
    },
    // 查询列表
    getList () {
      this.loading = true
      // 处理日期范围
      const params = { ...this.queryParams };
      if (params.eqptDateRange && params.eqptDateRange.length === 2) {
        params.eqptDate = params.eqptDateRange[0];
        params.eqptDateEnd = params.eqptDateRange[1];
      }
      delete params.eqptDateRange;

      queryEqptVerificationList(params).then(res => {
        if (res.retCode === 'ok') {
          this.tableData = res.additionalData.records;
          this.queryParams.currPage = res.additionalData.current;
          this.queryParams.pageSize = res.additionalData.size;
          this.total = res.additionalData.total;
        }
        this.loading = false;
      })
    },
    // 新增按钮
    handleAdd () {
      this.$refs.addEdit.openDialog('Add');
    },
    // 修改按钮
    handleEdit (row) {
      this.$refs.addEdit.openDialog('Edit', row);
    },
    // 导出按钮
    exportToExcel () {
      this.$message.success('正在导出标准数据...')

      // 调用导出接口
      exportEqptVerificationExcel(this.queryParams).then(response => {
        // 创建下载链接
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);

        // 创建下载链接元素
        const link = document.createElement('a');
        link.href = url;
        link.download = '设备检定信息.xlsx'; // 文件名

        // 触发下载
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$message.success('导出成功')
      }).catch(error => {
        console.error('导出失败:', error)
        this.$message.error('导出失败：' + (error.message || '未知错误'))
      })
    },
    // 删除按钮
    handleDelete (row) {
      this.$confirm('确定删除该设备检定信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteEqptVerification(row.id).then(res => {
          if (res.retCode === 'ok') {
            this.$message.success('删除成功')
            this.getList()
          }
        })
      })
    },
    // 下载文件
    downloadFile (fileOrUrl) {
      let fileUrl = '';
      let fileName = '未知文件';

      // 判断传入的是文件对象还是文件URL
      if (typeof fileOrUrl === 'string') {
        // 如果是字符串，视为直接的URL
        fileUrl = fileOrUrl;
      } else if (fileOrUrl && fileOrUrl.loadFileUrl) {
        // 如果是文件对象，获取URL和文件名
        fileUrl = fileOrUrl.loadFileUrl;
        fileName = fileOrUrl.fileName || fileName;
      }

      // 检查文件URL是否存在
      if (!fileUrl) {
        this.$message.warning('文件下载地址无效');
        return;
      }

      try {
        // 创建一个隐藏的a标签
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = fileUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$message.success('文件下载已开始');
      } catch (error) {
        console.error('下载文件失败:', error);
        this.$message.error('下载文件失败');
      }
    },
  }
};
</script>
<style scoped>
.loading-container {
  padding: 20px;
  text-align: center;
}
.no-data {
  padding: 20px;
  text-align: center;
  color: #909399;
}
.file-item {
  margin: 5px 0;
}
.file-list {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
}
.file-separator {
  margin: 0 2px;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>